<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <div>
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>
         <!-- Code added -->
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">
            <b-row class="col-md-12 lgtypelist mt-3">
                 
            <div class="col mx-1">

              <b-input-group class="mt-2">
                            
                <ejs-multiselect
                  id="selected_segment_id"
                  placeholder="Select Segment"
                  v-model="selected_segment_id"
                  name="selected_segment_id"
                  :fields="segementid_fields"
                  :dataSource="segmentarray_list"
                  :showSelectAll="true"
                  :class="{ input: true }"
                >
                </ejs-multiselect>
              </b-input-group>

              <!-- <label>Gender</label>
                <b-form-group>
                  <b-form-select @change="showCollection(brand_id, selected_segment_id)"
                    v-model="selected_segment_id"
                    id="selected_segment_id"
                    name="selected_segment_id"
                    placement="Select Gender"
                  >
                    <option :value="null">--Select Gender--</option>
                    <option v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                      segmentlist.seg_name
                    }}</option>
                  </b-form-select>
                </b-form-group> -->
            </div> 
            <div class="col mx-1">
              <b-input-group class="mt-2">
                            
                <ejs-multiselect
                  id="selected_collection_id"
                  placeholder="Select Season"
                  v-model="selected_collection_id"
                  name="selected_collection_id"
                  :fields="collectionid_fields"
                  :dataSource="collectionData"
                  :showSelectAll="true"
                  :popupSettings="{ showCheckBox: true, mode: 'CheckBox' }"
                  :class="{ input: true }"
                 >
                </ejs-multiselect>

              </b-input-group>
              <!-- <label>Season</label>
               <b-form-group >
                  <b-form-select @change="showSubcategory(selected_collection_id)"
                    v-model="selected_collection_id"
                    id="selected_collection_id"
                    name="selected_collection_id"
                  >
                    <option :value="null">--Select Season--</option>
                    <option v-for="collection in collectionData" :value="collection.collection_id" :key="collection.collection_id">{{
                      collection.collection_title
                    }}</option>
                  </b-form-select>
                </b-form-group> -->
            </div> 
            <div class="col mx-1">

              <b-input-group class="mt-2">
                            
                <ejs-multiselect
                  id="sub_catid"
                  placeholder="Select Sub-Category"
                  v-model="sub_catid"
                  name="sub_catid"
                  :fields="subcatid_fields"
                  :dataSource="sub_cat_id_arr"
                  :showSelectAll="true"
                  :class="{ input: true }"
                >
                </ejs-multiselect>
              </b-input-group>

              <!-- <label>Sub-category</label>
                 <b-form-group >
                  <b-form-select @change="getPoTypeList(sub_catid);"
                    v-model="sub_catid"
                    id="sub_catid"
                    name="sub_catid"
                  >
                    <option :value="null">--Select Sub-category--</option>
                    <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" :key="subcatarry.sub_catid">{{
                      subcatarry.sub_cattitle
                    }}</option>
                  </b-form-select>
                </b-form-group> -->
            </div>
             <div class="col mx-1">
              <b-input-group class="mt-2">
                            
                <ejs-multiselect
                  id="selected_po_id"
                  placeholder="Select PO Id"
                  v-model="selected_po_id"
                  name="selected_po_id"
                  :fields="poid_fields"
                  :dataSource="po_typearr"
                  :showSelectAll="true"
                  :class="{ input: true }"
                >
                </ejs-multiselect>
              </b-input-group>
              <!-- <label>PO Type (PT)</label>
                <b-form-group >
                
                  <b-form-select
                    v-model="selected_po_id"
                    id="selected_po_id"
                    name="selected_po_id"
                  >
                    <option :value="null">--Select PO Type--</option>
                    <option v-for="polist in po_typearr" :value="polist.po_id" :key="polist.po_id">{{
                      polist.potype_title
                    }}</option>
                  </b-form-select>
                </b-form-group> -->
            </div> 
            <div class="col mx-1">
              <label></label>
              <b-form-group>
               <b-button @click="searchData(brand_id)"
                      type="submit"
                      variant="primary"
                      class="px-4 pull-left"
                      >Search</b-button
                    >
                  <button
                    class="btn btn-sm btn-primary ml-3 px-3 pb-2"
                    v-on:click="refresh()"
                    type="button"
                  >
                    <i class="fa fa-refresh"></i>
                  </button>
                </b-form-group>
            </div> 
 
          </b-row>
          <hr>
            <label style="margin-left: 20px;">All Designs : </label>         
            <b-row class="boxto">     
       

                <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                 <router-link  :to="'/style_list/' +'ALL_Designs' + ',' + this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{ALL_Designs}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="My Designs"> All Designs</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
            </b-row>
            <hr style="height:30px">
            <label style="margin-left: 20px;">Design Styles : </label>         
            <b-row class="boxto">     
        <b-col sm="6" lg="2" >

                <b-card no-body class="bg-aqua"  >
                    <router-link :to="'/style_list/' + 'Designs_Pending_For_Approval'+ ',' + this.brand_id1 +','+this.brand_type" >
                  <b-card-body class="pb-0">     
                   
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">{{Designs_Pending_For_Approval}} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">Designs pending for approval</p>
                  </b-card-body>
                   </router-link>   


                </b-card>
              </b-col>
                    <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                <router-link  :to="'/style_list/' +'Designs_Approved' +','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs approve)">{{Designs_Approved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs approved"> Designs approved</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>


              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def" >
                <router-link  :to="'/style_list/' +'Designs_Rejected'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Designs_Rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Designs rejected</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green" >
                <router-link  :to="'/style_list/' +'Designs_Feedback'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Designs_Feedback}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Designs Feedback</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
             
            
            
            </b-row>
            <hr style="height:30px">




            <label style="margin-left: 20px;">Files : </label>         
            <b-row class="boxto">     
        <b-col sm="6" lg="2" >

                <b-card no-body class="bg-aqua"  >
                    <router-link :to="'/style_list/' + 'Tech_Pack_Uploaded'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">{{Tech_Pack_Uploaded}} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Designs pending for approval">Tech Pack Uploaded</p>
                  </b-card-body>
                   </router-link>   


                </b-card>
              </b-col>
                    <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                <router-link  :to="'/style_list/' +'BOM_Uploaded' +','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs approve)">{{BOM_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs approved"> BOM Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>


              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def" >
                <router-link  :to="'/style_list/' +'Measurment_Chart_Uploaded'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Measurment_Chart_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Measurement Chart Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green"  >
                <router-link  :to="'/style_list/' +'All_Files_Uploaded'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="All Files Uploaded)">{{All_Files_Uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Designs approved"> All Files Uploaded</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

             
            
            
            </b-row>
            <hr style="height:30px">


              <!-- Code added -->
           <label style="margin-left: 20px;">Quotations:</label>         
            <b-row class="boxto">  

         <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                <router-link  :to="'/style_list/' +'Quotation_pending'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="In quotation">{{Quotation_pending}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="In quotation">Quotation pending</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

       
                   <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                <router-link  :to="'/style_list/' +'In_Quotation'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Quotation pending)">{{In_Quotation}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation pending">In quotation</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
               

           

              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-def" >
                  <router-link  :to="'/style_list/' +'Quotation_received'+','+this.brand_id1 +','+this.brand_type">
                      <b-card-body class="pb-0">  
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Quotation received">{{Quotation_received}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor " v-b-tooltip.hover title="Quotation received">Quotation received</p>
                  </b-card-body>   
                  </router-link>     
                </b-card>
              </b-col>

               <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green" >
                  <router-link  :to="'/style_list/' +'Quotation_approved'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">
                            
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title=" Quotation approved">{{Quotation_approved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation approved">Quotation approved</p>
                  </b-card-body>
                   </router-link>            
                </b-card>
              </b-col>   

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-pink" >
                  <router-link  :to="'/style_list/' +'Quotation_rejected'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">
                            
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title=" Quotation Rejected">{{Quotation_rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Quotation Rejected">Quotation Rejected</p>
                  </b-card-body>
                   </router-link>            
                </b-card>
              </b-col>
             
             </b-row>
             <hr style="height:30px">             
          
            <label style="padding-top: 10px!important; margin-left: 20px;">Sampling</label><br/>
            <label style="margin-left: 20px;">Proto Sampling :</label>                 
            <b-row class="boxto"> 
              
                <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-aqua" >
                        <router-link  :to="'/style_list/' +'proto_sampling_pending'+','+this.brand_id1 +','+this.brand_type">
                        <b-card-body class="pb-0">          
                          <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling pendin)" >{{proto_sampling_pending}}</h4>
                          <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling pending">Proto Sampling pending</p>
                        </b-card-body> 
                        </router-link>       
                      </b-card>
                </b-col>

                <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal" >
                      <router-link  :to="'/style_list/' +'proto_sampling_rejected'+','+this.brand_id1 +','+this.brand_type">
                      <b-card-body class="pb-0">          
                        <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling requested" >{{proto_sampling_rejected}}</h4>
                        <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling requested">Proto Sampling Rejected</p>
                      </b-card-body> 
                      </router-link>       
                    </b-card>
                </b-col>
                      
                <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def" >
                      <router-link  :to="'/style_list/' +'proto_sampling_approved'+','+this.brand_id1 +','+this.brand_type">
                      <b-card-body class="pb-0">          
                        <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Proto Sampling approved" >{{proto_sampling_approved}}</h4>
                        <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Proto Sampling approved">Proto Sampling approved</p>
                      </b-card-body> 
                      </router-link>       
                    </b-card>
                </b-col>


              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal">
                   <router-link  :to="'/style_list/' +'proto_dispatched'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Proto Dispatched">
                    {{proto_dispatched}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Proto Dispatched"> Proto Dispatched</p>
                  </b-card-body> 
                 </router-link>       
                </b-card>
              </b-col> 
            </b-row>

            <label style="margin-left: 20px;" class="">PP :</label> 
            <b-row>

              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-green" >
                  <router-link  :to="'/style_list/' +'pp_pending'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP pending" >{{pp_pending}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="PP pending">PP pending</p>
                  </b-card-body> 
                  </router-link>       
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-pink" >
                  <router-link  :to="'/style_list/' +'pp_sampling_requested'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP requested" >{{pp_sampling_requested}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="PP requested">PP requested</p>
                  </b-card-body> 
                  </router-link>       
                </b-card>
              </b-col>
               
               
               <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-red">
                  <router-link  :to="'/style_list/' +'pp_approved'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="PP approved">{{pp_approved}}</h4>
                    <p  style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP approve">PP approved</p>
                  </b-card-body>
                    </router-link>        
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua">
                   <router-link  :to="'/style_list/' +'pp_rejected'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PO Createdd">
                    {{pp_rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP Rejected"> PP Rejected</p>
                  </b-card-body> 
                 </router-link>       
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def">
                   <router-link  :to="'/style_list/' +'pp_dispatched'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="PP Dispatched">
                    {{pp_dispatched}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="PP Dispatched"> PP Dispatched</p>
                  </b-card-body> 
                 </router-link>       
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>






  <div >
      <b-row>
        <b-col cols="12">
        <!--  <b-breadcrumb :items="breadcrumbs"/> -->
         <!-- Code added -->
          <b-card >
           <!-- Code added by Sachin
            Date:12/02/2020 -->

            <!-- Code End -->
            <!-- <strong class="heading">Orders</strong>  -->    
            
            
            <hr style="height:30px">

              <label style="margin-left: 20px;">PO</label>
              <b-row class="boxto">
                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-aqua">
                    <router-link :to="'/style_list/' + 'PO_Created'+','+this.brand_id1 +','+this.brand_type">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Created"
                        >
                          {{ PO_Created }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Created"
                        >
                          PO Created
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-def">
                    <router-link :to="'/style_list/' + 'PO_Generated'+','+this.brand_id1 +','+this.brand_type">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Generated"
                        >
                          {{ PO_Generated }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Generated"
                        >
                          PO Generated
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>

                <b-col sm="6" lg="2">
                  <b-card no-body class="bg-purpal">
                    <router-link :to="'/style_list/' + 'PO_initiated'+','+this.brand_id1 +','+this.brand_type">
                      <b-card-body class="pb-0">
                        <h4
                          class="mb-0 display-4 text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Initiated"
                        >
                          {{ PO_initiated }}
                        </h4>
                        <p
                          style="padding-bottom: 20px;"
                          class="text-center countcolor"
                          v-b-tooltip.hover
                          title="PO Initiated"
                        >
                          PO Initiated
                        </p>
                      </b-card-body>
                    </router-link>
                  </b-card>
                </b-col>
              </b-row>

             <hr style="height:30px">

             <label style="margin-left: 20px;">TNA</label>
             <b-row class="boxto">     
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def" >
                  <router-link  :to="'/style_list/' +'tna_uploaded'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="TNA Uploaded)" > {{tna_uploaded}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="TNA Uploaded">TNA Uploaded</p>
                  </b-card-body> 
                   </router-link>        
                </b-card>
              </b-col>
                
              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-pink">
                    <router-link  :to="'/style_list/' +'TNA_approved'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA approved"> {{tna_approved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" TNA approved"> TNA approved</p>
                  </b-card-body>
                  </router-link>       
                </b-card>
              </b-col>  

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green">
                  <router-link  :to="'/style_list/' +'tna_modified'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA Modified"> {{tna_modified}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor " v-b-tooltip.hover title="TNA Modified">TNA Modified</p>
                  </b-card-body>
                   </router-link>               
                </b-card>
              </b-col>  

              <div style="display:none;">
                  <b-col sm="6" lg="2" >
              <b-card no-body class="bg-green">
                <router-link  :to="'/style_list/' +'tna_feedback'+','+this.brand_id1 +','+this.brand_type">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA submitted"> {{tna_feedback}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor " v-b-tooltip.hover title="TNA submitted">TNA Feedback</p>
                </b-card-body>
                 </router-link>               
              </b-card>
            </b-col>   
            <b-col sm="6" lg="2" >
              <b-card no-body class="bg-pink">
                  <router-link  :to="'/style_list/' +'tna_rejected'+','+this.brand_id1 +','+this.brand_type">
                <b-card-body class="pb-0">          
                  <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="TNA rejected"> {{tna_rejected}}</h4>
                  <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" TNA rejected"> TNA Rejected</p>
                </b-card-body>
                </router-link>       
              </b-card>
            </b-col> 

              </div>

             
            </b-row> 
        <hr style="height:30px">

          <label style="margin-left: 20px;">Orders</label>
             <b-row class="boxto" >     
              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-aqua">
                   <router-link  :to="'/style_list/' +'Order_pending'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Order pendin">
                    {{Order_pending}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Order pending">Order pending</p>
                  </b-card-body> 
                   </router-link>         
                </b-card>
              </b-col>
              
              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-purpal">
                 <router-link  :to="'/style_list/' +'Order_submitted'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Order submitted"> {{Order_submitted}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor"  v-b-tooltip.hover title="Order submitted">Order submitted</p>
                  </b-card-body>
                
                   </router-link>             
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" class="pointer">
                <b-card no-body class="bg-def" >
                  <router-link  :to="'/style_list/' +'Order_received'+','+this.brand_id1 +','+this.brand_type">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Order received" > {{Order_received}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Order received">Order received</p>
                  </b-card-body> 
                   </router-link>       
                </b-card>
              </b-col>
               
        
             
               
            </b-row>
                   





            
          </b-card>
        </b-col>
      </b-row>
    </div>




  </div>
</div>
 
           
          
</template>


<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth";
 import Router from 'vue-router'
const axios = require('axios');
export default {
  name: 'dashboard',
  data: function () {
    return {
      name: 'dashboard',
      id: '',
      Firstmile:[],
      Lasttmile:[],
      Reverse:[],
     a:-1,
    pending_for_approval: 0,
    Designapproved:0,
    designrejected: 0,

      inprogress: 0,
      approved: 0,
      pending: 0,
      received: 0,



      ALL_Designs: 0,
     Order_pending: 0,
     Order_received: 0,
     Order_submitted: 0,
    // In_production: 0,
    PO_Updated: 0,
      PO_Created: 0,
      PO_submitted:0,
    TNA_approved: 0,
    tna_rejected: 0,
    tna_modified: 0,
    tna_uploaded:0 ,
    tna_approved: 0,
    TNA_pending: 0,
    TNA_submitted: 0,


    pp_sample_approved: 0,
    pp_sample_pending: 0,
    pp_sample_requested: 0,
    proto_sample_approved: 0,
    proto_sample_pending: 0,
    proto_sample_requested: 0,
    Quotationsapproved:0,

    rejected: 0,
    resultData:[],
    Designs_Approved : 0,
    Designs_Rejected : 0,
    Designs_Feedback: 0,
    Designs_Pending_For_Approval : 0,
    BOM_Uploaded: 0,
    Measurment_Chart_Uploaded: 0,
    Tech_Pack_Uploaded: 0,
    All_Files_Uploaded: 0,
    In_Quotation : 0,
    Quotation_pending : 0,
    Quotation_received : 0,
    Quotation_approved : 0,
    Quotation_rejected: 0,
    proto_sampling_pending : 0,
    proto_sampling_rejected : 0,
    proto_sampling_approved : 0,
    pp_pending : 0,
    pp_sampling_requested : 0,
    pp_approved : 0,
    pp_rejected: 0,
    proto_dispatched: 0,
    pp_dispatched: 0,


    PO_CreatedPO_submitted : 0,
    TNA_pending : 0,
    TNA_submitted : 0,
    TNA_approved : 0,
    In_Preparation:0,
    In_Production:0,
    Ready_for_Dispatch:0,

    Order_pending : 0,
    Order_submitted : 0,
    Order_received : 0,
    PO_Generated: 0,
    PO_initiated: 0,
    // localStorageBrandId : '',
       breadcrumbs: [{
        text: 'Dashboard',
        active: true
      }],
    // Search Data
      segmentarray_list: [],
      selected_segment_id: null,
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      selected_collection_id: null,
      brand_id: '',
      segment_id: '',
      segmentList_arr: [],
      totalRows: 0,
      sub_catid: "",
      sub_cat_id_arr: [],
      po_typearr: [],
      sub_catid: null,
      selected_po_id: null,
      result:[],
      route_id:'',
      brand_id1:[],
      brand_type:'',
      routeData:'',
      segementid_fields: { text: "text", value: "value" },
      collectionid_fields:  { text: "text", value: "value" },
      subcatid_fields: { text: "text", value: "value" },
      poid_fields:  { text: "text", value: "value" },
    }
  },
 
  created: function () {
    this.routeData = this.$route.params.id.split(',')
    this.brand_id = this.routeData[0];
    this.brand_type = this.routeData[1];
     var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)

   // this.sub_cat_id_arr = userInfo[0].subcat_assign;
   this.showCollection(this.brand_id)
   this.showSubcategory(this.selected_collection_id,userInfo[0].user_id)
   this.getPoTypeList(this.sub_catid,userInfo[0].user_id)
    this.displayDashboardData();
    this.getBrandSegmentList(this.brand_id);
    // this.displayDashboardData();
         this.route_id = this.$route.params.id;
    const myArr = this.route_id.split(",");
    // const mysubcatArr = this.route_id;
    if(myArr[0])
    {
        this.brand_id1 = myArr[0];
    }
    if(myArr[1]){
      this.brand_type = myArr[1];
    }
    // this.route_status = myArr[0];
    // console.log("HHHHHH", this.route_status);
    // this.selected_brand_id = myArr[1];
    if(myArr && myArr != 'undefined'){
      localStorage.setItem('brand_id',myArr[0])
    }

  },

  mounted() {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)

    let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : null
    
    if(tempLocalStorage){
      if(tempLocalStorage.selected_segment_id){
        this.selected_segment_id = tempLocalStorage.selected_segment_id
        this.showCollection((userInfo[userInfo.length-1].brand_id ? userInfo[userInfo.length-1].brand_id : null),tempLocalStorage.selected_segment_id)
        this.selected_collection_id = tempLocalStorage.selected_collection_id
        if(tempLocalStorage.selected_collection_id){
          this.showSubcategory(tempLocalStorage.selected_collection_id)
        }
        this.sub_catid = tempLocalStorage.sub_catid
        if(tempLocalStorage.sub_catid){
          this.getPoTypeList(tempLocalStorage.sub_catid)
        }
        this.selected_po_id = tempLocalStorage.selected_po_id
      }
      
    }
    this.displayDashboardData();
    this.getBrandSegmentList(this.brand_id);
  },

  methods: {
    
      displayDashboardData: function () {
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData)
         var temp_data=userInfo[0];
        //  var localStorageBrandId = this.$route.params.id
         userInfo.push({'brand_id':this.brand_id})
          localStorage.setItem('userData', JSON.stringify(userInfo));
         // if(userInfo.length>1){
         //  alert("oo")
         //  localStorage.setItem('userData', '')
         //  console.log("vvvvvvvvvvv",userData)
         //  localStorage.setItem('userData', JSON.stringify(temp_data))
         //  var userData = localStorage.getItem('userData');
         //  var userInfo = JSON.parse(userData)
         //  // userInfo=temp_data;
         //  console.log(">>>>>>>>>>>>>>>>>",userInfo)
         //  
         // }
         // else{
         //  alert("else")
         //  var userData = localStorage.getItem('userData');
         //  var userInfo = JSON.parse(userData)
         //  userInfo.push({'brand_id':this.$route.params.id})
         //  localStorage.setItem('userData', JSON.stringify(userInfo));
         // }
         // console.log("TTTTTTTTTTTTTT",userInfo);
      
         
         var userData = localStorage.getItem('userData');
         var userInfo = JSON.parse(userData)
         var localbrandid = localStorage.getItem('brand_id');
          // localStorage.setItem('brand_id', this.$route.params.id)
         // localStorage.setItem('brand_id', JSON.stringify(this.$route.params.id))
         // localStorage.setItem('userData', JSON.stringify(userData))
         
        const Obj = {
            user_id:userInfo[0].user_id,
            user_type:userInfo[0].user_type,
            brand_id: this.brand_id,
            segment_id: this.selected_segment_id ? this.selected_segment_id : null,
            collection_id: this.selected_collection_id ? this.selected_collection_id : null,
            sub_catid: this.sub_catid ? this.sub_catid : null,
            po_id: this.selected_po_id ? this.selected_po_id : null   ,
            brand_type:this.brand_type ? this.brand_type : null  
          }
        
      axios.post(`${CONSTANTS.API_URL}/getdashboardcountforadmin`,Obj)
                .then(response => {
                 var result = response.data
                 this.resultData = response.data.returnvalue[0]
                
          if (result.returnmsg === 'Successful') {
              if(this.resultData.Design_Styles.Designs_Approved=='' || this.resultData.Design_Styles.Designs_Approved==null || this.resultData.Design_Styles.Designs_Approved==undefined){
                      this.Designs_Approved= 0;
              }
              else{
                this.Designs_Approved= this.resultData.Design_Styles.Designs_Approved
              }
              if(this.resultData.All_Designs.ALL_Designs=='' || this.resultData.All_Designs.ALL_Designs==null || this.resultData.All_Designs.ALL_Designs==undefined){
                this.ALL_Designs= 0;
              }
              else{
                this.ALL_Designs= this.resultData.All_Designs.ALL_Designs
              }
              if(this.resultData.Design_Styles.Designs_Rejected=='' || this.resultData.Design_Styles.Designs_Rejected==null || this.resultData.Design_Styles.Designs_Rejected==undefined){
                            this.Designs_Rejected= 0;
              }
              else{
                this.Designs_Rejected= this.resultData.Design_Styles.Designs_Rejected
              }
              if(this.resultData.Design_Styles.Designs_Feedback=='' || this.resultData.Design_Styles.Designs_Feedback==null || this.resultData.Design_Styles.Designs_Feedback==undefined){
                            this.Designs_Feedback= 0;
              }
              else{
                this.Designs_Feedback= this.resultData.Design_Styles.Designs_Feedback
              }
              if(this.resultData.Design_Styles.Designs_Pending_For_Approval=='' || this.resultData.Design_Styles.Designs_Pending_For_Approval==null || this.resultData.Design_Styles.Designs_Pending_For_Approval==undefined){
                            this.Designs_Pending_For_Approval= 0;
              }
              else{
                this.Designs_Pending_For_Approval= this.resultData.Design_Styles.Designs_Pending_For_Approval
              }
       
             if(this.resultData.PO.PO_Generated=='' || this.resultData.PO.PO_Generated==null || this.resultData.PO.PO_Generated==undefined){
                this.PO_Generated= 0;
              }
              else{
                this.PO_Generated= this.resultData.PO.PO_Generated;
              }

              if(this.resultData.PO.PO_initiated=='' || this.resultData.PO.PO_initiated==null || this.resultData.PO.PO_initiated==undefined){
                this.PO_initiated= 0;
                }
              else{
                this.PO_initiated= this.resultData.PO.PO_initiated;
              }
      
              if(this.resultData.Files.BOM_Uploaded=='' || this.resultData.Files.BOM_Uploaded==null || this.resultData.Files.BOM_Uploaded==undefined){
                            this.BOM_Uploaded= 0;
              }
              else{
                this.BOM_Uploaded= this.resultData.Files.BOM_Uploaded
              }

              if(this.resultData.Files.Measurment_Chart_Uploaded=='' || this.resultData.Files.Measurment_Chart_Uploaded==null || this.resultData.Files.Measurment_Chart_Uploaded==undefined){
                            this.Measurment_Chart_Uploaded= 0;
              }
              else{
                this.Measurment_Chart_Uploaded= this.resultData.Files.Measurment_Chart_Uploaded
              }

              if(this.resultData.Files.Tech_Pack_Uploaded=='' || this.resultData.Files.Tech_Pack_Uploaded==null || this.resultData.Files.Tech_Pack_Uploaded==undefined){
                            this.Tech_Pack_Uploaded= 0;
              }
              else{
                this.Tech_Pack_Uploaded= this.resultData.Files.Tech_Pack_Uploaded
              }
              if(this.resultData.Files.All_Files_Uploaded=='' || this.resultData.Files.All_Files_Uploaded==null || this.resultData.Files.All_Files_Uploaded==undefined){
                              this.All_Files_Uploaded= 0;
              }
              else{
                this.All_Files_Uploaded= this.resultData.Files.All_Files_Uploaded
              }
              
              if(this.resultData.Quotations.In_Quotation=='' || this.resultData.Quotations.In_Quotation==null || this.resultData.Quotations.In_Quotation==undefined){
                            this.In_Quotation= 0;
              }
              else{
                this.In_Quotation= this.resultData.Quotations.In_Quotation
              }

              if(this.resultData.Quotations.Quotation_pending=='' || this.resultData.Quotations.Quotation_pending==null || this.resultData.Quotations.Quotation_pending==undefined){
                            this.Quotation_pending= 0;
              }
              else{
                this.Quotation_pending= this.resultData.Quotations.Quotation_pending
              }
              if(this.resultData.Quotations.Quotation_received=='' || this.resultData.Quotations.Quotation_received==null || this.resultData.Quotations.Quotation_received==undefined){
                            this.Quotation_received= 0;
              }
              else{
                this.Quotation_received= this.resultData.Quotations.Quotation_received
              }
            
              if(this.resultData.Quotations.Quotation_approved=='' || this.resultData.Quotations.Quotation_approved==null || this.resultData.Quotations.Quotation_approved==undefined){
                            this.Quotation_approved= 0;
              }
              else{
                this.Quotation_approved= this.resultData.Quotations.Quotation_approved
              }
              if(this.resultData.Quotations.Quotation_rejected=='' || this.resultData.Quotations.Quotation_rejected==null || this.resultData.Quotations.Quotation_rejected==undefined){
                            this.Quotation_rejected= 0;
              }
              else{
                this.Quotation_rejected =this.resultData.Quotations.Quotation_rejected     
              }
              

              if(this.resultData.Sampling.proto_sampling_pending=='' || this.resultData.Sampling.proto_sampling_pending==null || this.resultData.Sampling.proto_sampling_pending==undefined){
                this.proto_sampling_pending= 0;
                }
              else{
                this.proto_sampling_pending= this.resultData.Sampling.proto_sampling_pending;
              }

              if(this.resultData.Sampling.proto_sampling_rejected=='' || this.resultData.Sampling.proto_sampling_rejected==null || this.resultData.Sampling.proto_sampling_rejected==undefined){
                this.proto_sampling_rejected= 0;
                }
              else{
                this.proto_sampling_rejected= this.resultData.Sampling.proto_sampling_rejected;
              }

              if(this.resultData.Sampling.proto_sampling_approved=='' || this.resultData.Sampling.proto_sampling_approved==null || this.resultData.Sampling.proto_sampling_approved==undefined){
                this.proto_sampling_approved= 0;
                }
              else{
                this.proto_sampling_approved= this.resultData.Sampling.proto_sampling_approved;
              }

              if(this.resultData.Sampling.pp_pending=='' || this.resultData.Sampling.pp_pending==null || this.resultData.Sampling.pp_pending==undefined){
                this.pp_pending= 0;
                }
              else{
                this.pp_pending= this.resultData.Sampling.pp_pending;
              }

              if(this.resultData.Sampling.pp_sampling_requested=='' || this.resultData.Sampling.pp_sampling_requested==null || this.resultData.Sampling.pp_sampling_requested==undefined){
                this.pp_sampling_requested= 0;
                }
              else{
                this.pp_sampling_requested= this.resultData.Sampling.pp_sampling_requested;
              }

              if(this.resultData.Sampling.pp_approved=='' || this.resultData.Sampling.pp_approved==null || this.resultData.Sampling.pp_approved==undefined){
                this.pp_approved= 0;
                }
              else{
                this.pp_approved= this.resultData.Sampling.pp_approved;
              }
              
              if(this.resultData.Sampling.pp_rejected=='' || this.resultData.Sampling.pp_rejected==null || this.resultData.Sampling.pp_rejected==undefined){
                this.pp_rejected= 0;
                }
              else{
                this.pp_rejected= this.resultData.Sampling.pp_rejected;
              } 

              if(this.resultData.Sampling.proto_dispatched=='' || this.resultData.Sampling.proto_dispatched==null || this.resultData.Sampling.proto_dispatched==undefined){
                this.proto_dispatched= 0;
                }
              else{
                this.proto_dispatched= this.resultData.Sampling.proto_dispatched;
              }

              if(this.resultData.Sampling.pp_dispatched=='' || this.resultData.Sampling.pp_dispatched==null || this.resultData.Sampling.pp_dispatched==undefined){
                this.pp_dispatched= 0;
                }
              else{
                this.pp_dispatched= this.resultData.Sampling.pp_dispatched;
              }


        // this.PO_Created= this.resultData.PO.PO_Created
        // this.PO_submitted= this.resultData.PO.PO_submitted
        // this.TNA_pending= this.resultData.PO.TNA_pending
        // this.TNA_submitted= this.resultData.PO.TNA_submitted
        // this.TNA_approved= this.resultData.PO.TNA_approved
        // this.In_production= this.resultData.PO.In_production

        // this.Order_pending= this.resultData.Orders.Order_pending
        // this.Order_submitted= this.resultData.Orders.Order_submitted
        // this.Order_received= this.resultData.Orders.Order_received

                  // this.PO_Created= this.resultData.PO.PO_Created
                  // this.PO_submitted= this.resultData.PO.PO_submitted

                  if(this.resultData.PO.PO_Created=='' || this.resultData.PO.PO_Created==null || this.resultData.PO.PO_Createdd==undefined){
                      this.PO_Created= 0;
                      }
                    else{
                      this.PO_Created= this.resultData.PO.PO_Created;
                    }

                    if(this.resultData.PO.PO_Updated=='' || this.resultData.PO.PO_Updated==null || this.resultData.PO.PO_Updated==undefined){
                      this.PO_Updated= 0; 
                      }
                    else{
                      this.PO_Updated= this.resultData.PO.PO_Updated;
                    }

                    if(this.resultData.PO.PO_Created=='' || this.resultData.PO.PO_Created==null || this.resultData.PO.PO_Created==undefined){
                      this.PO_Created= 0;
                      }
                    else{
                      this.PO_Created= this.resultData.PO.PO_Created;
                    }

                    if(this.resultData.PO.PO_submitted=='' || this.resultData.PO.PO_submitted==null || this.resultData.PO.PO_submitted==undefined){
                      this.PO_submitted= 0;
                      }
                    else{
                      this.PO_submitted= this.resultData.PO.PO_submitted;
                    }
    
                  // this.tna_uploaded= this.resultData.Tna.tna_uploaded
                  if(this.resultData.Tna.tna_uploaded=='' || this.resultData.Tna.tna_uploaded==null || this.resultData.Tna.tna_uploaded==undefined){
                      this.tna_uploaded= 0;
                      }
                    else{
                      this.tna_uploaded= this.resultData.Tna.tna_uploaded;
                    }
                    if(this.resultData.Tna.TNA_submitted=='' || this.resultData.Tna.TNA_submitted==null || this.resultData.Tna.TNA_submitted==undefined){
                      this.TNA_submitted= 0;
                      }
                    else{
                      this.TNA_submitted= this.resultData.Tna.TNA_submitted;
                    }  
                    if(this.resultData.Tna.tna_feedback=='' || this.resultData.Tna.tna_feedback==null || this.resultData.Tna.tna_feedback==undefined){
                      this.tna_feedback= 0;
                      }
                    else{
                      this.tna_feedback= this.resultData.Tna.tna_feedback;
                    }
                    if(this.resultData.Tna.tna_rejected=='' || this.resultData.Tna.tna_rejected==null || this.resultData.Tna.tna_rejected==undefined){
                      this.tna_rejected= 0;
                      }
                    else{
                      this.tna_rejected= this.resultData.Tna.tna_rejected
                    }
                    if(this.resultData.Tna.tna_approved=='' || this.resultData.Tna.tna_approved==null || this.resultData.Tna.tna_approved==undefined){
                      this.tna_approved= 0;
                      }
                    else{
                      this.tna_approved= this.resultData.Tna.tna_approved;
                    }

                    if(this.resultData.Tna.tna_modified=='' || this.resultData.Tna.tna_modified==null || this.resultData.Tna.tna_modified==undefined){
                      this.tna_modified= 0;
                      }
                    else{
                      this.tna_modified= this.resultData.Tna.tna_modified;
                    }

                    if(this.resultData.Tna.tna_approved=='' || this.resultData.Tna.tna_approved==null || this.resultData.Tna.tna_approved==undefined){
                      this.tna_approved= 0;
                      }
                    else{
                      this.tna_approved= this.resultData.Tna.tna_approved;
                    }

                    if(this.resultData.Tna.tna_uploaded=='' || this.resultData.Tna.tna_uploaded==null || this.resultData.Tna.tna_uploaded==undefined){
                      this.tna_uploaded= 0;
                      }
                    else{
                      this.tna_uploaded= this.resultData.Tna.tna_uploaded;
                    }
                    

                    if(this.resultData.Tna.tna_rejected=='' || this.resultData.Tna.tna_rejected==null || this.resultData.Tna.tna_rejected==undefined){
                      this.tna_rejected= 0;
                      }
                    else{
                      this.tna_rejected= this.resultData.Tna.tna_rejected;
                    }
                            
                    if(this.resultData.PO.In_Preparation=='' || this.resultData.PO.In_Preparation==null || this.resultData.PO.In_Preparation==undefined){
                      this.In_Preparation= 0;
                      }
                    else{
                      this.In_Preparation= this.resultData.PO.In_Preparation;
                    }

                    if(this.resultData.PO.In_Production=='' || this.resultData.PO.In_Production==null || this.resultData.PO.In_Production==undefined){
                      this.In_Production= 0;
                      }
                    else{
                      this.In_Production= this.resultData.PO.In_Production;
                    }

                    if(this.resultData.PO.Ready_for_Dispatch=='' || this.resultData.PO.Ready_for_Dispatch==null || this.resultData.PO.Ready_for_Dispatch==undefined){
                      this.Ready_for_Dispatch= 0;
                      }
                    else{
                      this.Ready_for_Dispatch= this.resultData.PO.Ready_for_Dispatch;
                    }

                    if(this.resultData.Orders.Order_pending=='' || this.resultData.Orders.Order_pending==null || this.resultData.Orders.Order_pending==undefined){
                      this.Order_pending= 0;
                      }
                    else{
                      this.Order_pending= this.resultData.Orders.Order_pending;
                    }
                    if(this.resultData.Orders.Order_submitted=='' || this.resultData.Orders.Order_submitted==null || this.resultData.Orders.Order_submitted==undefined){
                      this.Order_submitted= 0;
                      }
                    else{
                      this.Order_submitted= this.resultData.Orders.Order_submitted;
                    }
                    if(this.resultData.Orders.Order_received=='' || this.resultData.Orders.Order_received==null || this.resultData.Orders.Order_received==undefined){
                      this.Order_received= 0;
                      }
                    else{
                      this.Order_received= this.resultData.Orders.Order_received;
                    }
    
     
           }  
           else{
            this.$fire({
              text:"No Data Found",
              type: "warning",
              timer: 30000
            }); 
           } 
        
        })        
    },

    searchData:function(brand_id){
      this.updateFilters();
      this.displayDashboardData();
    },

       // Search function api's

        /****** Function to Get Brand & Segments ********/
    getBrandSegmentList:function(brand_id){
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");

      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        
        var obj = {
          brand_id
        };
        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentListForAdminAndVendor`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              // document.getElementById("overlay").style.display = "none";
              this.segmentarray_list = this.result.returnvalue;

              // this.isMultipleVndorSelected = false
              let tempsegement_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.segment_title
                  tempobj.value = item.segment_title
                  tempsegement_list.push(tempobj)

                })
                this.segmentarray_list = tempsegement_list

            }
            else{
              this.segmentList_arr = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            this.errors.push(e);
          });

      }
    },

        // Collection list accorfing to segment selected
    showCollection(brand_id) {
      this.selected_collection_id=null,
      this.sub_catid=null,
      this.selected_po_id=null,
      this.sub_cat_id_arr = [];
      this.po_typearr = [];

      // document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      // this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      var user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: brand_id,
        // segment_id: segment_id,
        user_id:  userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

             this.collectionData = response.data.returnvalue.collections;
             let tempcollction_list =[]
                response.data.returnvalue.collections.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.collection_title
                  tempobj.value = item.collection_title
                  tempcollction_list.push(tempobj)

                })
              this.collectionData = tempcollction_list
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
    },

        /******Function To Get Sub Category List********/

      // Sub Category list accorfing to segment selected
        showSubcategory(collection_id,user_id) {
          //this.updateFilters(); 
          this.sub_catid = null,
          this.selected_po_id = null,
          this.po_typearr = [];

          // document.getElementById("overlay").style.display = "block";
          var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)

          const Obj = {
            collection_id,
            user_id:  user_id ? user_id : userInfo[0].user_id,
          };

          axios
            .post(`${CONSTANTS.API_URL}/getSubcategoryForDashboardFilter`, Obj)
            .then((response) => {
              document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
                this.sub_cat_id_arr = response.data.returnvalue;
                // sub_cattitle
                let tempsubcat_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.sub_cattitle
                  tempobj.value = item.sub_catid
                  tempsubcat_list.push(tempobj)

                })
              this.sub_cat_id_arr = tempsubcat_list

              }else{
                this.sub_cat_id_arr = []
              }
            })
            .catch((e) => {
                this.errors.push(e);
              });
                
        },


        /******Function To Get PO Type List********/
    getPoTypeList: function(subcat_id,user_id) {
      this.selected_po_id = null;

      // document.getElementById("overlay").style.display = "block";
       var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData)

      // this.isBusy = true;
      const Obj = {
        subcat_id,
        user_id:  user_id ? user_id : userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.po_typearr = this.result.returnvalue;
            // this.totalRows = this.result.returnvalue.length;
            // this.isBusy = !this.isBusy;
            let temppo_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.title
                  tempobj.value = item.po_id
                  temppo_list.push(tempobj)

                })
              this.po_typearr = temppo_list
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    updateFilters(){
        
        const filters = {
          "selected_segment_id" : this.selected_segment_id,
          "selected_collection_id" : this.selected_collection_id,
          "sub_catid": this.sub_catid,
          "selected_po_id": this.selected_po_id
        };
        localStorage.setItem('filters',JSON.stringify(filters));
      },

    refresh: function () {
      this.collectionData = [];
      this.sub_cat_id_arr = [];
      this.po_typearr = [];
      this.selected_segment_id = null,
        this.selected_collection_id = null,
        this.sub_catid = null,
        this.selected_po_id = null,
        localStorage.removeItem('filters');
        this.showCollection(this.brand_id)
        this.showSubcategory(this.selected_collection_id)
        this.getPoTypeList(this.sub_catid)
        this.displayDashboardData();

    },

  }
}

</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
      width: 150px;
  height: 140px;
  margin-left: 20px;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
   width: 150px;
  height: 140px;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
     width: 150px;
  height: 140px;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
       width: 150px;
  height: 140px;
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
       width: 150px;
  height: 140px;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  width: 150px;
  height: 140px;
}
.boxto .card-body{
  padding: 0px!important;
}
.heading{
  padding: 12px 12px 5px 12px!important;
}
.countcolor
{
      color:white !important;

}
.pointer
{
  cursor: pointer!important;
}

</style>